import type { SerializerOptions } from '@ember-data/legacy-compat';
import type { Snapshot } from '@ember-data/legacy-compat/-private';

import type { RecordAttributes, RecordData } from 'webapp-types';
import { omit } from 'webapp/utils/common';

import ApplicationSerializer from 'webapp/serializers/application';

import type TemplateRecord from 'webapp/models/template';

export default class TemplateSerializer extends ApplicationSerializer {
	override getReadOnlyFields(_json: Record<string, unknown>): RecordData.Template.ReadOnlyKey[] {
		return ['token', 'metricKeys', 'images', 'sources', 'usedCount'];
	}

	override serialize(
		snapshot: Snapshot,
		options: SerializerOptions,
	): RecordData.Template.Serialized {
		// read-only fields are already removed by ApplicationSerializer
		const attributes = super.serialize(snapshot, options) as Omit<
			RecordAttributes<TemplateRecord>,
			RecordData.Template.ReadOnlyKey
		>;

		return attributes.isPublic
			? attributes
			: omit(attributes, 'createdBy', 'categories', 'keywords');
	}
}
